/**
 * @generated SignedSource<<2dd6bcd273ad87694a7c703c86c654e5>>
 * @relayHash a9db3f2f9d36f0fcdf6cd82148289d9c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ac325b338576722cf180666afab3d18763b7e18c34cebb0b8c66c5f968064c84

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraFieldOptionIdsFilterOperation = "ALLOW" | "EXCLUDE" | "%future added value";
export type JiraFieldOptionIdsFilterInput = {
  operation: JiraFieldOptionIdsFilterOperation;
  optionIds: ReadonlyArray<string>;
};
export type singleSelectFieldOptions_singleSelectEditView$variables = {
  after?: string | null | undefined;
  filterById?: JiraFieldOptionIdsFilterInput | null | undefined;
  first?: number | null | undefined;
  id: string;
  searchBy?: string | null | undefined;
};
export type singleSelectFieldOptions_singleSelectEditView$data = {
  readonly " $fragmentSpreads": FragmentRefs<"singleSelect_issueFieldSingleSelectEditviewFull_SingleSelectEditViewWithFieldOptionsFragment">;
};
export type singleSelectFieldOptions_singleSelectEditView = {
  response: singleSelectFieldOptions_singleSelectEditView$data;
  variables: singleSelectFieldOptions_singleSelectEditView$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterById"
  },
  {
    "defaultValue": 100,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": "",
    "kind": "LocalArgument",
    "name": "searchBy"
  }
],
v1 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v2 = {
  "kind": "Variable",
  "name": "filterById",
  "variableName": "filterById"
},
v3 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v4 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "id"
},
v5 = {
  "kind": "Variable",
  "name": "searchBy",
  "variableName": "searchBy"
},
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = [
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/),
  (v5/*: any*/)
],
v8 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "singleSelectFieldOptions_singleSelectEditView",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "singleSelect_issueFieldSingleSelectEditviewFull_SingleSelectEditViewWithFieldOptionsFragment"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "singleSelectFieldOptions_singleSelectEditView",
    "selections": [
      {
        "args": [
          (v4/*: any*/)
        ],
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v7/*: any*/),
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "fieldOptions",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": "value",
                            "kind": "ScalarField",
                            "name": "id"
                          },
                          {
                            "alias": "label",
                            "kind": "ScalarField",
                            "name": "value"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "optionId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isDisabled"
                          },
                          (v8/*: any*/),
                          (v6/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ]
              },
              {
                "args": (v7/*: any*/),
                "filters": [
                  "searchBy",
                  "filterById"
                ],
                "handle": "connection",
                "key": "main_issueFieldSingleSelectEditviewFull__fieldOptions",
                "kind": "LinkedHandle",
                "name": "fieldOptions"
              }
            ],
            "type": "JiraSingleSelectField"
          },
          (v8/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "ac325b338576722cf180666afab3d18763b7e18c34cebb0b8c66c5f968064c84",
    "metadata": {},
    "name": "singleSelectFieldOptions_singleSelectEditView",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "486432386804a49898ed5dad76c1f148";

export default node;
